/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Explorer_Display_Delete_Records_TextInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to delete {count} selected record(s)?" |
*
* @param {Explorer_Display_Delete_Records_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_delete_records_text = /** @type {((inputs: Explorer_Display_Delete_Records_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_Delete_Records_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Voulez-vous supprimer ${i?.count} enregistrement(s) selectionne(s) ?`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Möchten Sie die ausgewählten Datensätze ${i?.count} wirklich löschen?`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Sei sicuro di voler eliminare ${i?.count} record selezionati?`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Вы уверены, что хотите удалить выбранную(ые) запись(и) ${i?.count}?`)
	if (locale === "es") return /** @type {LocalizedString} */ (`¿Está seguro de que desea eliminar ${i?.count} los registros seleccionados?`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`您确定要删除 ${i?.count} 选定的记录吗？`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`選択したレコード ${i?.count} を削除してもよろしいですか?`)
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्या आप वाकई चयनित रिकॉर्ड (या रिकॉर्ड) को हटाना चाहते हैं?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Tem certeza de que deseja excluir o(s) registro(s) selecionado(s) ${i?.count}?`)
	return /** @type {LocalizedString} */ (`Are you sure you want to delete ${i?.count} selected record(s)?`)
});